import { RouteType } from "types/RouteType";

// Admin security settings — global password policy + locked-account unlock.
// Backed by 'password-policies' (admin-gated via requireUserAdmin) and the
// 'user' service (lockedUntil/failedLoginAttempts reset).
const securitySettingsRoute: RouteType = {
  name: "SecuritySettings",
  path: "/admin/security-settings",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Security Settings",
      enableRefreshButton: false,
      color: "primary",
    },
    body: {
      component: () => import("./SecuritySettings"),
      grayBackground: true,
    },
  },
  group: "Admin",
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
};

export default securitySettingsRoute;
